/* Mega menu: snippets/mm-mega-menu.liquid (desktop) and mm-mega-drawer.liquid (phones).
   Opens on hover or keyboard, loads each link's products from
   sections/mm-mega-products.liquid, and adds to the cart drawer from the +. */
(function () {
  /* Restaurants and Markets links point at #mmx-<section> on those pages.
     Shopify prefixes section ids with a template id that differs between
     theme copies, so match the id's ending instead of the full id. */
  function mmxTarget(hash) {
    if (!hash || hash.indexOf('#mmx-') !== 0) return null;
    const suffix = hash.slice(5).replace(/[^\w-]/g, '');
    return suffix ? document.querySelector(`[id$="__${suffix}"]`) : null;
  }

  function scrollToSection(hash, smooth) {
    const target = mmxTarget(hash);
    if (!target) return false;
    // The sticky header hides while scrolling down and returns on the way up,
    // so only leave room for it when the section is above the current spot.
    const header = document.querySelector('.section-header');
    const goingUp = target.getBoundingClientRect().top < 0;
    const offset = (goingUp && header ? header.getBoundingClientRect().height : 0) + 16;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    return true;
  }

  if (window.location.hash.indexOf('#mmx-') === 0) {
    window.addEventListener('load', () => scrollToSection(window.location.hash));
  }
  window.addEventListener('hashchange', () => scrollToSection(window.location.hash, true));

  // Same page, another section: hashchange does not fire when the hash is
  // unchanged, so handle the click directly.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#mmx-"]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname) return;
    if (!mmxTarget(url.hash)) return;
    event.preventDefault();
    history.replaceState(null, '', url.hash);
    const drawer = link.closest('header-drawer');
    // Close the drawer the way its own button does; calling Dawn's
    // closeMenuDrawer() alone leaves the drawer and its backdrop open.
    const toggle = drawer && drawer.querySelector('details[open] > summary');
    if (toggle) toggle.click();
    scrollToSection(url.hash, true);
    document.dispatchEvent(new CustomEvent('mmx:close'));
  });

  const nav = document.querySelector('[data-mmx]');
  if (!nav) return;

  const SECTION = 'mm-mega-products';
  const OPEN_DELAY = 90;
  const CLOSE_DELAY = 180;
  const cache = new Map();
  let openItem = null;
  let openTimer = 0;
  let closeTimer = 0;

  const items = Array.from(nav.querySelectorAll('[data-mmx-item]'));

  function sectionUrl(src) {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('section_id', SECTION);
    return url.toString();
  }

  function load(src) {
    if (!cache.has(src)) {
      const request = fetch(sectionUrl(src), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const root = doc.querySelector('.mmx-psec') || doc.body;
          return root.innerHTML;
        })
        .catch((error) => {
          cache.delete(src);
          throw error;
        });
      cache.set(src, request);
    }
    return cache.get(src);
  }

  function showProducts(item, link) {
    const body = item.querySelector('[data-mmx-body]');
    const title = item.querySelector('[data-mmx-title]');
    const all = item.querySelector('[data-mmx-all]');
    if (!body || !link) return;

    item.querySelectorAll('.mmx-subs .mmx-rowbtn').forEach((row) => row.classList.toggle('is-on', row === link));

    const name = link.querySelector('.n').textContent.trim();
    const src = link.dataset.mmxSrc;
    title.textContent = name;
    all.textContent = `shop all ${name} →`;
    all.href = link.getAttribute('href');
    body.dataset.src = src;
    body.classList.add('is-loading');

    load(src)
      .then((html) => {
        if (body.dataset.src !== src) return;
        body.innerHTML = html;
        body.classList.remove('is-loading');
      })
      .catch(() => {
        if (body.dataset.src !== src) return;
        body.innerHTML = '<p class="mmx-empty mmx-b">couldn’t load these products. open the link to see them.</p>';
        body.classList.remove('is-loading');
      });
  }

  function showCategory(item, index) {
    item.querySelectorAll('.mmx-rail [data-mmx-cat]').forEach((row) => row.classList.toggle('is-on', row.dataset.mmxCat === index));
    let first = null;
    item.querySelectorAll('.mmx-sublist').forEach((list) => {
      const on = list.dataset.mmxCat === index;
      list.hidden = !on;
      if (on) first = list.querySelector('[data-mmx-src]');
    });
    if (first) showProducts(item, first);
  }

  function open(item) {
    clearTimeout(closeTimer);
    if (openItem === item) return;
    if (openItem) close(openItem);
    openItem = item;
    item.classList.add('is-open');
    item.querySelector('.mmx-top').setAttribute('aria-expanded', 'true');
    if (!item.querySelector('.mmx-rail .is-on')) {
      const firstCat = item.querySelector('.mmx-rail [data-mmx-cat]');
      if (firstCat) showCategory(item, firstCat.dataset.mmxCat);
    }
  }

  function close(item) {
    item.classList.remove('is-open');
    item.querySelector('.mmx-top').setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }

  function closeAll() {
    clearTimeout(openTimer);
    if (openItem) close(openItem);
  }

  items.forEach((item) => {
    const top = item.querySelector('.mmx-top');

    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => open(item), openItem ? 0 : OPEN_DELAY);
    });
    item.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => close(item), CLOSE_DELAY);
    });

    // Items without their own page toggle the panel; the rest navigate.
    if (top.tagName === 'BUTTON') {
      top.addEventListener('click', () => (item.classList.contains('is-open') ? close(item) : open(item)));
    }
    top.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        open(item);
        const first = item.querySelector('.mmx-mega a, .mmx-mega button');
        if (first) first.focus();
      }
    });

    item.querySelectorAll('.mmx-rail [data-mmx-cat]').forEach((row) => {
      const go = () => showCategory(item, row.dataset.mmxCat);
      row.addEventListener('mouseenter', go);
      row.addEventListener('focus', go);
      if (row.tagName === 'BUTTON') row.addEventListener('click', go);
    });

    item.querySelectorAll('[data-mmx-src]').forEach((link) => {
      const go = () => showProducts(item, link);
      link.addEventListener('mouseenter', go);
      link.addEventListener('focus', go);
    });
  });

  // Touch screens wide enough for this menu (an iPad held sideways) have no
  // hover, so a tap on a link would leave before its panel or products could
  // be seen. A press on a link whose panel or products are not showing yet
  // opens them instead, and a second press follows the link. A mouse that has
  // been resting on the link for a moment has already opened it, so normal
  // clicks are unaffected. iPadOS can report taps as mouse pointers, so this
  // goes by what is on screen rather than by pointer type.
  const HOVER_SETTLE = 120;
  let touchTap = null;
  let hoverTarget = null;
  let hoverSince = 0;

  nav.addEventListener('mouseover', (event) => {
    const target = event.target.closest('.mmx-top, [data-mmx-cat], [data-mmx-src]');
    if (target !== hoverTarget) {
      hoverTarget = target;
      hoverSince = Date.now();
    }
  });

  nav.addEventListener('pointerdown', (event) => {
    touchTap = null;
    const target = event.target.closest('.mmx-top, [data-mmx-cat], [data-mmx-src]');
    const item = target && target.closest('[data-mmx-item]');
    if (!target || !item || target.tagName !== 'A') return;
    const showing = target.classList.contains('mmx-top') ? item.classList.contains('is-open') : target.classList.contains('is-on');
    const rested = event.pointerType === 'mouse' && hoverTarget === target && Date.now() - hoverSince > HOVER_SETTLE;
    touchTap = { target, item, ready: showing || rested };
  }, true);

  nav.addEventListener('click', (event) => {
    const tap = touchTap;
    touchTap = null;
    if (!tap || tap.ready || !tap.target.contains(event.target)) return;
    event.preventDefault();
    if (tap.target.classList.contains('mmx-top')) {
      clearTimeout(openTimer);
      open(tap.item);
    } else if (tap.target.dataset.mmxSrc) {
      showProducts(tap.item, tap.target);
    } else {
      showCategory(tap.item, tap.target.dataset.mmxCat);
    }
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' && openItem && !nav.contains(event.target)) closeAll();
  });

  nav.addEventListener('focusin', (event) => {
    const item = event.target.closest('[data-mmx-item]');
    if (item) open(item);
    else closeAll();
  });

  document.addEventListener('focusin', (event) => {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener('mmx:close', closeAll);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openItem) return;
    const top = openItem.querySelector('.mmx-top');
    closeAll();
    top.focus();
  });

  // Close when the sticky header hides on scroll.
  window.addEventListener('scroll', () => {
    if (openItem && window.scrollY > 0 && document.querySelector('.shopify-section-header-hidden')) closeAll();
  }, { passive: true });

  // Quick add
  nav.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-mmx-add]');
    if (!button || button.classList.contains('is-busy')) return;
    event.preventDefault();
    addToCart(button);
  });

  const PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M7 1v12M1 7h12" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  const CHECK = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1.5 7.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function showAdded(button) {
    const label = button.getAttribute('aria-label');
    button.classList.add('is-done');
    button.innerHTML = CHECK;
    button.setAttribute('aria-label', 'Added to cart');
    setTimeout(() => {
      button.classList.remove('is-done');
      button.innerHTML = PLUS;
      button.setAttribute('aria-label', label);
    }, 1800);
  }

  function refreshCart(cart, sections) {
    if (typeof cart.getSectionsToRender !== 'function') return;
    cart.getSectionsToRender().forEach((section) => {
      const html = sections[section.id];
      if (!html) return;
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function addToCart(button) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const card = button.closest('.mmx-card');
    const oldError = card.querySelector('.err');
    if (oldError) oldError.remove();

    const formData = new FormData();
    formData.append('id', button.dataset.mmxAdd);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    button.classList.add('is-busy');
    button.setAttribute('aria-disabled', 'true');

    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const error = document.createElement('span');
          error.className = 'err mmx-b';
          error.textContent = response.description || response.message || 'couldn’t add this item.';
          card.appendChild(error);
          return;
        }
        if (!cart) {
          window.location = window.routes ? window.routes.cart_url : '/cart';
          return;
        }
        showAdded(button);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mega-menu', productVariantId: button.dataset.mmxAdd, cartData: response });
        }
        // Add in the background (client, Oct 16): refresh the cart count and
        // the drawer's contents without opening it, so shoppers keep browsing.
        cart.classList.remove('is-empty');
        refreshCart(cart, response.sections || {});
      })
      .catch(() => {
        const error = document.createElement('span');
        error.className = 'err mmx-b';
        error.textContent = 'couldn’t add this item. please try again.';
        card.appendChild(error);
      })
      .finally(() => {
        button.classList.remove('is-busy');
        button.removeAttribute('aria-disabled');
      });
  }
})();
